export enum SignUpTargets {
    HOMEOWNER = 'homeowner',
    BOARD_MEMBER = 'self-managed',
    PROPERTY_MANAGER = 'property-manager',
}
